export default __webpack_public_path__ + "static/media/alaska.4f29544c.jpeg";